import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useContent, ContentLoading } from "@/content/ContentProvider";
import ContentBlocks from "@/content/ContentBlocks";
import PageHero from "@/components/site/PageHero";
import { PillButton } from "@/components/site/Kit";
import { PaperCard } from "@/components/site/HomeBottom";
import NotFound from "./NotFound";
export function ArticleCategory() {
  const { slug } = useParams();
  const { text: cmsText, ARTICLE_CATEGORIES, PAPERS, loading } = useContent();
  const category = ARTICLE_CATEGORIES.find((c) => c.slug === slug);
  useEffect(() => {
    if (category) document.title = category.title + " | Nomus";
  }, [category]);
  if (loading && !category) return <ContentLoading />;
  if (!category) return <NotFound />;
  const articles = PAPERS.filter(
    (p) => p.categories.includes(slug) && p.visibility !== "unlisted",
  );
  return (
    <>
      <PageHero
        label={cmsText("Managed.notes-label")}
        title={category.title}
        text={category.description}
      />
      <section className="px-5 pt-20">
        <div className="mx-auto grid max-w-[1400px] gap-x-3 gap-y-12 md:grid-cols-3">
          {articles.map((p) => (
            <PaperCard key={p.id} p={p} />
          ))}
        </div>
        {!articles.length && (
          <p className="mx-auto max-w-[1400px] text-[17px] opacity-60">
            {cmsText("Managed.empty-articles")}
          </p>
        )}
      </section>
    </>
  );
}
export function ManagedPage() {
  const { slug } = useParams();
  const { pages, PAPERS, loading } = useContent();
  const page = pages.find((p) => p.slug === slug);
  useEffect(() => {
    if (page) document.title = page.title + " | Nomus";
  }, [page]);
  if (loading && !page) return <ContentLoading />;
  if (!page) return <NotFound />;
  return (
    <>
      <PageHero label={page.label} title={page.title} text={page.description} />
      <section className="px-5 pt-20">
        <div className="mx-auto max-w-[900px]">
          <ContentBlocks blocks={page.body} />
          {page.cta && (
            <div className="mt-12">
              <PillButton href={page.cta.href}>{page.cta.label}</PillButton>
            </div>
          )}
        </div>
        {page.articleSlugs?.length > 0 && (
          <div className="mx-auto mt-20 grid max-w-[1400px] gap-8 md:grid-cols-3">
            {PAPERS.filter(
              (a) =>
                page.articleSlugs.includes(a.slug) &&
                a.visibility !== "unlisted",
            ).map((p) => (
              <PaperCard key={p.id} p={p} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
